import styled from 'styled-components';
const StyledAccordionFilterContainer = styled.div.withConfig({
  displayName: "StyledAccordionFilterContainer",
  componentId: "sc-16ymsho-0"
})(["padding:", ";margin:", ";"], ({
  padded = true
}) => padded ? '20px' : '0px', ({
  condensed
}) => condensed ? '8px 20px 0 20px' : 0);
export default StyledAccordionFilterContainer;